module.exports = __webpack_public_path__ + "img/浙江途众汽贸控股有限公司.7a438858.png";